module.exports = __webpack_public_path__ + "img/swiper3.adad8777.jpg";